import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { constantConfig } from 'web-common';
import { queryMenuContentList } from '../../store/action';
import { AboutUsMobile } from './IndexMobile';
import { AboutUsPC } from './IndexPC';


const { ModuleTypeEnum } = constantConfig;


/**
 * 关于我们
 * @constructor
 */
const AboutUs = () => {

	const { isMobile } = useSelector((state: any) => state.reducer);

	const [companyList, setCompanyList] = useState<any[]>([]);	// 公司列表


	useEffect(() => {
		queryContentList();
	}, []);


	/**
	 * 初始化内容列表
	 */
	const queryContentList = async () => {
		const result = await queryMenuContentList(ModuleTypeEnum.CONTACT);
		const arrs = result.data || [];
		if (Array.isArray(arrs)) {
			setCompanyList(arrs);
		}
	}; 

	if (isMobile) {
		return <AboutUsMobile companyList={companyList} />;
	}

	return <AboutUsPC companyList={companyList} />;
};


export default AboutUs;
